// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_3pt33","avatar":"avatar_6atxf","avatarContainer":"avatarContainer_e9wsq","mobileStyle":"mobileStyle_elmro"};